import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "weekdays-list"
}
const _hoisted_2 = { class: "schedule-list" }

import ExpansionPanel from '@/common/components/snedson-material-components/expansion-panel/expansion-panel.vue';
import UniversalCard from '@/common/components/snedson-material-components/universal-card/universal-card.vue';
import router from '@/router';
import { onMounted, reactive } from 'vue';
import { getWeekdayTitle } from '@/helpers/getWeekdayTitle';
import { getUsualTeacherScheduleSubpageByClassId } from './apiMethods';
import { UsualTeacherClassSubpageResponseModel } from './UsualTeacherClassSubpageResponseModel';
import { WeekDays } from '@/models/ScheduleLists/WeekDaysEnum';
import { getBaseUrl } from '@/http/api/';


export default /*#__PURE__*/_defineComponent({
  __name: 'UsualScheduleSubpage',
  setup(__props) {

const state = reactive<{ data: UsualTeacherClassSubpageResponseModel | null }>({
    data: null,
});

onMounted(() => {
    const classId = router.currentRoute.value.params.classId;
    getUsualTeacherScheduleSubpageByClassId(classId).then((res) => {
        state.data = res.data;
    });
});

return (_ctx: any,_cache: any) => {
  return (state.data !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(state.data.usEsForClass), (day) => {
          return (_openBlock(), _createBlock(ExpansionPanel, {
            props: { title: _unref(getWeekdayTitle)(day[0] as WeekDays) },
            key: day[0]
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day[1], (use, index) => {
                  return (_openBlock(), _createBlock(UniversalCard, {
                    key: index,
                    class: _normalizeClass(use.colorSchemeName),
                    props: {
                        type: 'filled',
                        title: `${use.num}. ${use.subjectFullName}`,
                        icon: _unref(getBaseUrl)() + use.iconURL,
                        dataTags: [
                            {
                                iconLocal: 'time.png',
                                title: `${
                                    state.data.usPs.usPs[day[0]][use.num - 1]
                                        .begin
                                } - ${
                                    state.data.usPs.usPs[day[0]][use.num - 1]
                                        .end
                                } (${
                                    state.data.usPs.usPs[day[0]][use.num - 1]
                                        .durationInMins
                                } мин.)`,
                                color: 'var(--snotra--sys--surface-variant)',
                            },
                            {
                                iconLocal: 'school.png',
                                color: 'var(--snotra--sys--surface-variant)',
                                title: use.location,
                            },
                            {
                                iconLocal: 'student.png',
                                color: 'var(--snotra--sys--surface-variant)',
                                title: use.groupName
                                    ? use.groupName
                                    : 'Весь класс ',
                            },
                            {
                                iconLocal: 'bell.png',
                                color: 'var(--snotra--sys--surface-variant)',
                                title: `Перемена после: ${
                                    state.data.usPs.usPs[day[0]][use.num - 1]
                                        .breakDurationInMins
                                } мин.`,
                            },
                        ],
                    }
                  }, null, 8, ["class", "props"]))
                }), 128))
              ])
            ]),
            _: 2
          }, 1032, ["props"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})